// Rodapiés por caja: la cantidad del carrito sigue contando tiras, nunca cajas.
(() => {
  if (window.MPBoxes) return;
  const round = (qty, size, allowZero = false) => {
    if (allowZero && Number(qty) === 0) return 0;
    return Math.max(1, Math.ceil((Number(qty) || 1) / size)) * size;
  };
  const text = (qty, size) => `${qty / size} caja${qty / size > 1 ? 's' : ''} (${qty} tiras)`;
  const rule = size => `Este producto se vende por cajas de ${size} tiras`;
  const notice = message => {
    // Fuera de las secciones reemplazadas por AJAX: el aviso no desaparece al refrescar el cajón.
    let status = document.querySelector('[data-mp-box-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-mp-box-status', '');
      status.setAttribute('role', 'status');
      status.className = 'text-sm';
      Object.assign(status.style, { position: 'fixed', bottom: '16px', left: '16px', right: '16px', zIndex: '100', padding: '12px', background: '#f8efe5', color: '#1c1c1c', boxShadow: '0 2px 12px #0002' });
      status.addEventListener('click', () => status.remove());
      document.body.append(status);
    }
    status.textContent = message;
  };
  const normalizeInput = input => {
    const size = Number(input.dataset.mpBoxSize);
    if (!(size > 1)) return;
    let qty = round(input.value, size, Boolean(input.closest('[allow-reset-to-zero]')));
    if (qty > 0) qty = Math.max(qty, Number(input.min) || size);
    if (Number(input.value) !== qty) notice(rule(size));
    input.value = qty;
  };
  const changedForms = new WeakSet();
  const prepareForm = form => {
    const data = form.closest('[data-mp-box-size]')?.dataset || {};
    const size = Number(data.mpBoxSize) || 1;
    const info = { unitType: data.mpUnitType, mode: Number(data.mpM2) > 0 || data.mpUnitType === 'm2' ? 'm2' : 'ml', unitSize: Number(data.mpM2) || Number(data.mpMl) || (data.mpUnitType === 'm2' ? 1 : 0), boxSize: size };
    if (!(size > 1) && !(info.mode === 'm2' && info.unitSize > 0)) return;
    const fields = [...form.elements].filter(field => field.name === 'quantity');
    const qty = round(fields[0]?.value, size);
    const set = (name, value) => {
      let field = [...form.elements].find(element => element.name === name);
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden'; field.name = name; form.append(field);
      }
      field.value = value;
    };
    fields.forEach(field => { field.value = qty; });
    set('quantity', qty);
    if (window.MPLineQuantity) {
      const props = Object.fromEntries([...form.elements].filter(field => /^properties\[.*\]$/.test(field.name)).map(field => [field.name.slice(11, -1), field.value]));
      const expected = props[info.mode === 'ml' ? '_piezas' : '_cajas'];
      const changed = changedForms.has(form) && (expected == null || Number(expected) !== qty);
      changedForms.delete(form);
      const final = window.MPLineQuantity.properties(props, qty, info, changed);
      for (const field of [...form.elements]) {
        if (['properties[_m2_solicitados]', 'properties[_ml_solicitados]', 'properties[_merma_pct]', 'properties[_piezas]'].includes(field.name) && !(field.name.slice(11, -1) in final)) field.remove();
      }
      Object.entries(final).forEach(([key, value]) => set(`properties[${key}]`, value));
    } else {
      if (info.mode === 'ml') set('properties[_piezas]', qty);
      set('properties[_cajas]', info.mode === 'm2' ? qty : qty / size);
    }
  };
  window.MPBoxes = { round, text, rule, notice, normalizeInput, prepareForm };
  // Captura antes de quantity-input: Prestige baja el valor inválido; aquí siempre subimos.
  document.addEventListener('change', event => {
    if (event.target.name === 'quantity') {
      const form = event.target.form || event.target.closest('form');
      if (form) changedForms.add(form);
    }
    if (event.target.matches('input[data-mp-box-size]')) normalizeInput(event.target);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/cart/add"]')) prepareForm(event.target);
  }, true);

  const attempted = new Set();
  try {
    for (const token of JSON.parse(sessionStorage.getItem('mp-box-attempts') || '[]')) attempted.add(token);
  } catch (error) {}
  let running = false;
  let scheduled = false;
  let ready = document.readyState === 'complete';
  const invalidLines = () => [...document.querySelectorAll('mp-box-line')].filter(line => {
    const size = Number(line.dataset.boxSize), qty = Number(line.dataset.quantity);
    return size > 1 && (qty < size || qty % size !== 0);
  });
  const schedule = () => {
    if (!ready || scheduled || running) return;
    scheduled = true;
    setTimeout(() => { scheduled = false; repair(); }, 0);
  };
  async function repair() {
    if (window.MPLineQuantity) { window.MPLineQuantity.schedule(); return; }
    if (running) return;
    running = true;
    let cart;
    let failed = false;
    try {
      // Página + cajón pueden contener la misma línea: se deduplica por clave y cantidad.
      for (const line of invalidLines()) {
        const { key, quantity, boxSize } = line.dataset;
        // Otro marcador de la misma línea puede haber quedado corregido durante este lote.
        if (Number(quantity) >= Number(boxSize) && Number(quantity) % Number(boxSize) === 0) continue;
        const token = `${key}:${quantity}`;
        if (attempted.has(token)) continue;
        attempted.add(token);
        try { sessionStorage.setItem('mp-box-attempts', JSON.stringify([...attempted])); } catch (error) {}
        // También tras un error: ningún bucle de reintentos/refrescos.
        try {
          const qty = round(quantity, Number(boxSize));
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty, sections: sections.join(',') }),
          });
          if (!response.ok) throw new Error('change.js');
          cart = await response.json();
          const updated = cart.items.find(item => item.key === key);
          if (updated && (updated.quantity < Number(boxSize) || updated.quantity % Number(boxSize))) {
            attempted.add(`${key}:${updated.quantity}`);
            try { sessionStorage.setItem('mp-box-attempts', JSON.stringify([...attempted])); } catch (error) {}
            throw new Error('Cantidad incompleta');
          }
          document.querySelectorAll('mp-box-line').forEach(marker => {
            if (marker.dataset.key === key) marker.dataset.quantity = String(updated?.quantity || qty);
          });
          notice(`${rule(boxSize)}. Cantidad ajustada a ${text(qty, Number(boxSize))}.`);
        } catch (error) {
          failed = true;
        }
      }
    } catch (error) {
      failed = true;
    } finally {
      running = false;
    }
    if (failed) notice('No se han podido ajustar las cajas del producto. Revisa la cantidad antes de continuar.');
    if (cart) {
      if (window.themeVariables?.settings?.pageType === 'cart') {
        // Una sola recarga después del lote; solo si el servidor ha confirmado las cajas completas.
        if (!failed) {
          try { sessionStorage.setItem('mp-box-notice', 'Se han ajustado las cantidades a cajas completas.'); } catch (error) {}
          window.location.reload();
        }
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart } }));
      }
    }
  }
  customElements.define('mp-box-line', class extends HTMLElement {
    connectedCallback() { schedule(); }
  });
  // Evita llegar al checkout mientras una línea antigua aún contiene una caja incompleta.
  const guardCheckout = event => {
    if (window.MPLineQuantity) return;
    const target = event.type === 'submit' ? (event.submitter?.matches('[name="checkout"]') ? event.submitter : null) : event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (target && (running || invalidLines().length)) {
      event.preventDefault(); event.stopImmediatePropagation();
      notice('Revisa las cajas completas del producto antes de continuar.');
    }
  };
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
  const start = () => {
    ready = true;
    // Una página con cantidades válidas termina el lote anterior; un HTML antiguo no lo repite.
    if (!invalidLines().length) {
      attempted.clear();
      try { sessionStorage.removeItem('mp-box-attempts'); } catch (error) {}
    }
    try {
      const message = sessionStorage.getItem('mp-box-notice');
      sessionStorage.removeItem('mp-box-notice');
      if (message) notice(message);
    } catch (error) {}
    schedule();
  };
  if (ready) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
